<div class="row mb-2">
  <label for="address" class="form-label">
    {{ label ? label : ("address.address" | translate) }}
    <span class="text-danger">*</span>
  </label>
  <div class="input-group mb-2">
    <input
      type="text"
      class="form-control"
      id="addressInput"
      disabled
      [value]="getFormattedAddressValue"
      readonly
      [placeholder]="'organization.address-placeholder' | translate"
    />
    <span class="input-group-text" (click)="openAddressModal()" role="button"  tabindex="-1">
      <i class="bi bi-search"></i>
      <!-- Bootstrap search icon -->
    </span>
    <span
      *ngIf="showMapButton"
      class="input-group-text"
      (click)="onNavigateIconClick()" role="button"  tabindex="-1"
    >
      <i class="bi bi-compass"></i>
      <!-- Bootstrap compass/navigate icon -->
    </span>
  </div>
  <div
    *ngIf="form.get('address')?.invalid && form.get('address')?.touched"
    class="text-danger"
  >
    <small *ngIf="form.get('address')?.errors?.['required']">{{
      "validation.required" | translate
    }}</small>
  </div>
</div>

<div class="row" *ngIf="hasAddressDescription">
  <div class="input-group">
    <input
      type="text"
      class="form-control"
      disabled
      [value]="addressDescriptionValue"
      readonly
      [placeholder]="
        'address.placeholder.address-description-placeholder' | translate
      "
    />
  </div>
</div>
